export default __webpack_public_path__ + "static/media/banner-img.eb1b281b.webp";